import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Phone } from "lucide-react";
import { GAEventTrack } from "../../utils/hooks/GA_events";
import { auth } from "../../config/firebaseConfig";

const CtaSection = () => {
  return (
    <section className="section cta" id="cta">
      {/* Grid pattern overlay */}
      <div className="grid-overlay"></div>

      <div className="container reveal-triggered zoom-in active" data-aos="zoom-in">
        <div className="cta-banner-content">
          <div className="badge cta-badge">
            <span>🚀</span> Join 20,000+ Students Learning Future Skills
          </div>

          <h2>Prepare Your Child for the <br /><span className="yellow-text">AI Future.</span></h2>

          <p>Every day they wait is a skill they will need tomorrow. Start their journey now — one free demo class, zero risk.</p>

          <div className="cta-banner-buttons">

            <Link
              to={auth?.currentUser ? "/dashboard?type=book-robotics-lab-demo" : "/register?type=book-robotics-lab-demo"}
              className="btn primary-btn"
              style={{ textDecoration: "none" }}
              onClick={() => GAEventTrack({ event: "ai-lab_demo_btn_click", data: { location: "/ai-robotics-coding-classes-for-kids" } })}
            >
              <Sparkles className="mr-1" />
              Book Free Demo
            </Link>
            <a
              href="tel:+911204514794"
              className="btn blue-btn"
              style={{ textDecoration: "none" }}
              onClick={() => GAEventTrack({ event: "talk_to_counsellor_click", data: { location: "bottom_cta" } })}
            >
              <Phone className="mr-1" size={16} />
              Talk to a Counsellor
            </a>
          </div>

          <div className="cta-features">
            <span className="cta-feature-item"><span className="dot-green"></span> Expert Mentors</span>
            <span className="cta-feature-item"><span className="dot-green"></span> Certified Courses</span>
            <span className="cta-feature-item"><span className="dot-green"></span> Project Portfolio</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
